<template>
  <v-img max-height="68" contain
    max-width="179"
    src="../../assets/hexalud_logo.png">
  </v-img>
</template>

<script>
export default {
  name: 'HexaludLogo'
}
</script>